import { Link } from "react-router-dom";
import { formatDate, formatNumber } from "../utils/format";

const SlideOver = ({ isOpen, community, guild, onClose }) => (
  <div
    className={`fixed inset-y-0 right-0 z-40 w-full max-w-md transform border-l border-brand-ink/50 bg-brand-midnight/95 p-6 transition duration-200 ${
      isOpen ? "translate-x-0" : "pointer-events-none translate-x-full"
    }`}
    aria-hidden={!isOpen}
  >
    <div className="flex items-center justify-between">
      <div>
        <p className="text-xs uppercase tracking-[0.3em] text-slate-500">Community</p>
        <h2 className="text-2xl text-slate-100">{community?.name ?? ""}</h2>
        {guild && <p className="text-sm text-slate-400">{guild.name}</p>}
      </div>
      <button
        onClick={onClose}
        className="rounded-full border border-brand-ink/50 px-3 py-1 text-xs text-slate-400 hover:text-slate-100"
      >
        Close
      </button>
    </div>

    {community && (
      <div className="mt-6 space-y-6 text-sm text-slate-300">
        <p>{community.summary}</p>
        <div className="grid grid-cols-2 gap-4 text-xs uppercase tracking-[0.3em] text-slate-500">
          <div>
            <p className="text-slate-100">{formatNumber(community.memberCount)}</p>
            <span>Members</span>
          </div>
          <div>
            <p className="text-slate-100">{community.region}</p>
            <span>Region</span>
          </div>
          <div>
            <p className="text-slate-100">{community.city}</p>
            <span>City</span>
          </div>
          <div>
            <p className="text-slate-100">{formatDate(community.launched)}</p>
            <span>Launched</span>
          </div>
        </div>

        <div className="flex flex-wrap gap-2">
          {community.tags.map((tag) => (
            <span key={tag} className="chip">
              {tag}
            </span>
          ))}
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-slate-500">Platforms</p>
          <div className="mt-2 flex flex-wrap gap-2">
            {community.platforms.map((platform) => (
              <a
                key={platform.url}
                href={platform.url}
                target="_blank"
                rel="noreferrer"
                className="rounded-full border border-brand-ink/50 px-3 py-1 text-xs font-semibold text-slate-100 hover:border-brand-primary"
              >
                {platform.type}
              </a>
            ))}
          </div>
        </div>

        <div className="flex gap-3 text-sm">
          <Link to={`/communities/${community.id}`} className="btn-primary">
            Open Profile
          </Link>
          <Link to={`/guilds/${community.guildId}`} className="btn-secondary">
            Guild Hub
          </Link>
        </div>
      </div>
    )}
  </div>
);

export default SlideOver;
